export const calcBundleDiscount = (isBundle: boolean, priceModel?: NordicNest.Api.PriceApiModel) => {
  if (!isBundle || !priceModel?.showDiscount || !priceModel?.regular) {
    return undefined;
  }

  const discountPercent =
    ((priceModel.regular.inclVat - priceModel.current.inclVat) / priceModel.regular.inclVat) * 100;

  return discountPercent >= priceModel.minimumDiscountSavePercentage ? `-${Math.round(discountPercent)}%` : undefined;
};
